// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/sxIconfont/iconfont.css'
import components from '@/components'
import '@/assets/less/index.less'
import vueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import 'swiper/dist/css/swiper.min.css'
// import request from '@/services/base'
import microApp from '@micro-zoe/micro-app'
// import 'leaflet/dist/leaflet.css'
// import 'leaflet.pm'
// import 'leaflet.pm/dist/leaflet.pm.css'
import { getConfigInfo } from '@/utils'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import * as filters from '@/filters'
import * as directives from '@/directives'
// 按需引入
import LuckDraw from 'vue-luck-draw'
// require('@/mock')
import '@webcomponents/custom-elements'
Object.keys(components).forEach(key => {
  if (!components[key].name) {
    return
  }
  Vue.component(components[key].name, components[key])
})

const setFilter = (value, type = 1) => {
  Object.keys(value).forEach(key => {
    if (type === 1) {
      if (typeof value[key] === 'function') {
        Vue.filter(key, value[key])
      } else {
        setFilter(value[key], type)
      }
    } else {
      Vue.directive(key, value[key])
    }
  })
}

setFilter(filters)
setFilter(directives, 2)

const setIco = () => {
  const item = getConfigInfo()
  console.log('🚀 ~ file: main.js:55 ~ setIco ~ item:', item)
  if (item) {
    let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = `/static/${item.subdomain}.ico`
    document.getElementsByTagName('head')[0].appendChild(link)
    document.title = item.name
  }
}

setIco()

Vue.use(vueAwesomeSwiper)
Vue.use(LuckDraw)
Vue.use(VXETable)

Vue.use(elementUI, { size: 'small' })

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (['/policy/list', '/policy/documentary'].includes(to.path)) {
    document.title = `${to.meta.title}-车险云平台` || '保险智能云平台'
  } else {
    document.title = '保险智能云平台'
  }
  // request.cancelRequest.source.cancel && request.cancelRequest.source.cancel('cancel request')
  // request.cancelRequest.source = request.CancelToken.source()
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#mainApp',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// 开启全局模块热替换：保存 .vue/.js 后浏览器自动应用，无需手动刷新
if (module.hot) {
  module.hot.accept()
}
microApp.start({
  'disable-memory-router': true, // 关闭虚拟路由系统
  'disable-patch-request': true, // 关闭对子应用请求的拦截
  'disable-scopecss': true, // 关闭子应用的样式隔离
  // 'disable-sandbox': true, // 关闭沙箱
  'disable-global-css': true, // 关闭全局css
  excludeAssetFilter (assets) {
    // console.log('🚀 ~ file: main.js:74 ~ excludeAssetFilter ~ assets', assets)
    if (assets.includes('f2.youbaolian.top')) {
      return true
    }
    return false
  },
  plugins: {
    modules: {
      'j-child': [{
        loader (code, url) {
          console.log('🚀 ~ file: main.js:84 ~ loader ~ url', url)
          return code.replace('var userInfo =', 'window.userInfo =').replace('avalon.profile', 'window.avalon.profile')
        }
      }]
    }
  }
  /**
   * 自定义fetch
   * @param {string} url 静态资源地址
   * @param {object} options fetch请求配置项
   * @param {string|null} appName 应用名称
   * @returns Promise<string>
  */
  /* fetch (url, options, appName) {
    console.log('🚀 ~ file: main.js:85 ~ fetch ~ url', url)
    if (url === 'http://localhost:3001/error.js') {
      // 删除 http://localhost:3001/error.js 的内容
      return Promise.resolve('')
    }

    const config = {
      // fetch 默认不带cookie，如果需要添加cookie需要配置credentials
      credentials: 'include' // 请求时带上cookie
    }

    if (url.includes(`cxv3.youbaolian.top`)) {
      return window.fetch(url, Object.assign(options, config)).then((res) => {
        return res.text()
      })
    }
    return window.fetch(url, Object.assign(options)).then((res) => {
      return res.text()
    })
  } */
})



// WEBPACK FOOTER //
// ./src/main.js